/*
* @描述: 开票详情
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-02-14 11:29:05
*/
<template>
    <el-dialog :before-close="handleDialogClose"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="dialogVisible"
               :modal-append-to-body="false"
               class="custom_form_dialog invoice_dialog"
               title="开票详情"
               width="620px">
        <el-form class="custom_detail_form"
                 label-position="top"
                 size="small">
            <el-row :gutter="24" style="flex-wrap: wrap" type="flex">
                <el-col :span="24">
                    <div class="page_little_title">
                        <span class="title">订单信息</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="关联订单" prop="order_num">
                        <span class="link-label" v-text="orderInfo.order_no"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="客户联系人" prop="contact_name">
                        <span v-if="orderInfo.contact_info" v-text="orderInfo.contact_info.name"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="page_little_title">
                        <span class="title">订单金额信息</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="订单总金额" prop="total_price">
                        <span v-text="orderInfo.total_price"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="已回款金额" prop="total_repay_price">
                        <span v-text="orderInfo.total_repay_price"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="待回款金额" prop="no_repay_price">
                        <span v-text="orderInfo.no_repay_price"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="实际回款金额" prop="repay_price">
                        <span v-text="orderInfo.repay_price"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="page_little_title">
                        <span class="title">开票申请信息</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="开票公司" prop="invoice_company_name">
                        <span v-text="invoiceInfo.invoice_company_name"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="发票类型" prop="invoice_type_name">
                        <span v-text="invoiceInfo.invoice_type_name"></span>
                    </el-form-item>
                </el-col>
                <el-col v-if="invoiceInfo.invoice_type===1||invoiceInfo.invoice_type===2" :span="12">
                    <el-form-item label="电子发票提供方式" prop="invoice_method_name">
                        <span v-text="invoiceInfo.invoice_method_name"></span>
                    </el-form-item>
                </el-col>
                <el-col v-if="invoiceInfo.invoice_type===1||invoiceInfo.invoice_type===2" :span="12">
                    <el-form-item label="电子收票邮箱" prop="invoice_email">
                        <span v-text="invoiceInfo.invoice_email"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="本次开票金额" prop="invoice_amount">
                        <span v-text="invoiceInfo.invoice_amount"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="开票对象" prop="invoice_title_type">
                        <span v-text="invoiceInfo.invoice_title_type_name"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="开票信息" prop="invoice_info">
                        <span v-text="invoiceInfo.invoice_info"></span>
                    </el-form-item>
                </el-col>
                <el-col v-if="invoiceInfo.invoice_type===3||invoiceInfo.invoice_type===4" :span="12">
                    <el-form-item label="收货人" prop="receive_name">
                        <span v-text="invoiceInfo.receive_name?invoiceInfo.receive_name:'--'"></span>
                    </el-form-item>
                </el-col>
                <el-col v-if="invoiceInfo.invoice_type===3||invoiceInfo.invoice_type===4" :span="12">
                    <el-form-item label="收货人电话" prop="receive_phone">
                        <span v-text="invoiceInfo.receive_phone?invoiceInfo.receive_phone:'--'"></span>
                    </el-form-item>
                </el-col>
                <el-col v-if="invoiceInfo.invoice_type===3||invoiceInfo.invoice_type===4" :span="24">
                    <el-form-item label="收货地址" prop="receive_addr">
                        <span v-text="invoiceInfo.receive_addr?invoiceInfo.receive_addr:'--'"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="备注" prop="apply_remark">
                        <span v-text="invoiceInfo.remark?invoiceInfo.remark:'--'"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="附件" prop="attachments">
                        <ul v-if="invoiceInfo.attachments&&invoiceInfo.attachments.length"
                            class="upload_file_list upload_file_list_detail">
                            <li v-for="(file,file_idx) in invoiceInfo.attachments"
                                class="upload_file_item">
                                <div class="file_left_wrap">
                                    <img alt="" class="file_img"
                                         src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                    <div class="file_info_wrap">
                                        <p class="file_name" v-text="file.file_name"></p>
                                        <p class="file_size" v-text="file.file_size"></p>
                                    </div>
                                </div>
                                <div class="file_right_wrap">
                                    <el-tooltip content="预览"
                                                effect="dark"
                                                placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                    </el-tooltip>
                                    <span class="line"></span>
                                    <el-tooltip content="下载"
                                                effect="dark"
                                                placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                  @click="handleClickDownloadFile(file)">
                                                <i class="iconfont icon-daochu"></i>
                                            </span>
                                    </el-tooltip>
                                </div>
                            </li>
                        </ul>
                        <span v-else>--</span>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-image ref="preview_img"
                  :preview-src-list="previewImgList"
                  :src="previewImgSrc"
                  style="display:none">
        </el-image>
    </el-dialog>
</template>
<script>
import {InvoiceDetail} from "@/api";
import {getOSSData} from "@/utils/uploadOss";

export default {
    name: "InvoiceDetailsDialog",
    data() {
        return {
            loading: false,
            invoiceInfo: {},
            orderInfo: {},
            previewImgList: [],
            previewImgSrc: ''
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        invoice_no: {
            type: String,
            default: '',
        },
    },
    created() {
        this.getInvoiceDetail()
    },
    mounted() {
    },
    methods: {
        // 详情
        getInvoiceDetail() {
            this.loading = true;
            InvoiceDetail({invoice_no: this.invoice_no}).then((res) => {
                if (res.code === 200) {
                    this.invoiceInfo = res.data.invoice_info;
                    this.orderInfo = res.data.order_info;
                } else {
                }
                this.loading = false;
            });
        },

        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
            this.$emit('update:invoice_no', '')
        },


        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不支持预览，请下载后查看')
                }
            }
        },

        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
    },
}
</script>
<style lang="scss">
.invoice_dialog .el-dialog__body {
    padding: 24px;
}
</style>